/*----------------------------------
  JavaScript
------------------------------------*/
// 100vhをiOSでも正しく表示させるためのハック
const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};
window.addEventListener("resize", setFillHeight);
setFillHeight();

// 画面幅が360px以下のときviewportを360pxに固定するためのハック
const viewport = document.querySelector('meta[name="viewport"]');
const switchViewport = () => {
  const value =
    window.outerWidth > 360
      ? "width=device-width,initial-scale=1"
      : "width=360";
  if (viewport.getAttribute("content") !== value) {
    viewport.setAttribute("content", value);
  }
};
window.addEventListener("resize", switchViewport);
switchViewport();

// クラシックエディタでフォトギャラリーを挿入したときに追加されるアンカーリンクを無効化する
const galleryItemLinks = document.querySelectorAll(".gallery-item a");
for (let i = 0; i < galleryItemLinks.length; i++) {
  galleryItemLinks[i].addEventListener(
    "click",
    (e) => {
      e.preventDefault();
    },
    false
  );
}

/*----------------------------------
  jQuery
------------------------------------*/
$(function () {
  const $window = $(window),
    min_xl = "screen and (min-width: 1040px)",
    min_xxl = "screen and (min-width: 1280px)",
    max_xxl = "screen and (max-width: 1279px)";

  /*----------------------------------
  トップページ・スクロール時のヘッダーの切り替え
  ------------------------------------*/
  $(".js-header").each(function () {
    const $header = $(this),
      threshold = $(".js-header-threshold").outerHeight();
    $window.on("scroll", function () {
      if (window.matchMedia(min_xl).matches) {
        // 画面幅が1040px以上のとき
        if ($window.scrollTop() > threshold) {
          // スクロール量>閾値のとき
          // ヘッダーをフェードインし、画面上部に固定する
          $header.fadeIn(400).addClass("header--sticky");
        } else {
          // ヘッダーをフェードアウトし、固定を解除する
          $header.fadeOut(400, function () {
            $header.removeClass("header--sticky");
          });
        }
      }
    });

    // ブラウザをリロードまたはリサイズしたとき、ヘッダーの表示をリセットするための処理
    $window.on("load resize", function () {
      if (window.matchMedia(min_xl).matches) {
        // 画面幅が1040px以上のとき
        // スクロールで表示されるヘッダーを非表示にして新たにスクロールイベントを発生させる
        $header.hide().removeClass("header--sticky");
        $window.trigger("scroll");
      } else {
        // 画面幅が1039px以下のとき
        $header.show().addClass("header--sticky");
      }
    });
  });

  /*----------------------------------
    ハンバーガーメニュー
  ------------------------------------*/
  $(".js-hamburger").on("click", function () {
    $("html").toggleClass("js-hamburger-open");
    // サブメニューをすべて非表示にする
    $(".js-gnav-sub-list").css("display", "none");
  });

  /*----------------------------------
    ヘッダーアコーディオンメニュー
  ------------------------------------*/
  $(".js-gnav-title").hover(function () {
    // 画面幅1280px以上のとき
    if (window.matchMedia(min_xxl).matches) {
      // ヘッダーメニューにホバーすることでサブメニューをスライドで表示する
      $(this).children(".js-gnav-sub-list").stop().slideToggle();
    }
  });

  $(".js-gnav-title").on("click", function () {
    // 画面幅1279px以下のとき
    if (window.matchMedia(max_xxl).matches) {
      // ヘッダーメニューをクリックすることでサブメニューをスライドで表示する
      $(this).children(".js-gnav-sub-list").stop().slideToggle();
    }
  });

  // トップページのメインビジュアル上ナビゲーションのみ有効
  $(".js-gnav-top-title").hover(function () {
    // 画面幅1280px以上のとき
    if (window.matchMedia(min_xl).matches) {
      // ヘッダーメニューにホバーすることでサブメニューをスライドで表示する
      $(this).children(".js-gnav-top-sub-list").stop().slideToggle();
    }
  });

  // ブラウザをリロードまたはリサイズしたとき
  $window.on("load resize", function () {
    // サブメニューをすべて非表示にする
    $(".js-gnav-sub-list").css("display", "none");
    $("html").removeClass("js-hamburger-open");
  });

  /*----------------------------------
    フッターアコーディオンメニュー
  ------------------------------------*/
  $(".footer__link-title").on("click", function () {
    if (window.matchMedia(max_xxl).matches) {
      $(this).next(".footer__link-menu").stop().slideToggle();
    }
  });
  $window.on("load resize", function () {
    if (window.matchMedia(max_xxl).matches) {
      $(".footer__link-title").next(".footer__link-menu").hide();
    } else {
      $(".footer__link-title").next(".footer__link-menu").show();
    }
  });

  /*----------------------------------
    園児たちの一日ページ・SP時のタイムライン表示切り替え
  ------------------------------------*/
  $(".js-timeline-junior").click(function () {
    $(".js-timeline-button-junior").removeClass(
      "timeline__button--junior-inactive"
    );
    $(".js-timeline-button-senior").addClass(
      "timeline__button--senior-inactive"
    );
    $(".js-junior").show();
    $(".js-senior").hide();
  });

  $(".js-timeline-senior").click(function () {
    $(".js-timeline-button-senior").removeClass(
      "timeline__button--senior-inactive"
    );
    $(".js-timeline-button-junior").addClass(
      "timeline__button--junior-inactive"
    );
    $(".js-junior").hide();
    $(".js-senior").show();
  });

  // 「0・1・2歳児」を初期表示にする
  if (window.matchMedia(max_xxl).matches) {
    $(".js-timeline-button-junior").removeClass(
      "timeline__button--junior-inactive"
    );
    $(".js-timeline-button-senior").addClass(
      "timeline__button--senior-inactive"
    );
    $(".js-junior").show();
    $(".js-senior").hide();
  } else {
    $(".js-junior").show();
    $(".js-senior").show();
  }

  $window.on("resize orientationchange", function () {
    // 「0・1・2歳児」を初期表示にする
    // スマホでは処理を行わない（アドレスバーの縮小によりresizeイベントが発火してしまうため）
    const userAgent = navigator.userAgent;
    if (
      (userAgent.indexOf("iPhone") > 0 || userAgent.indexOf("Android") > 0) &&
      userAgent.indexOf("Mobile") > 0
    ) {
      return false;
    }
    if (window.matchMedia(max_xxl).matches) {
      $(".js-timeline-button-junior").removeClass(
        "timeline__button--junior-inactive"
      );
      $(".js-timeline-button-senior").addClass(
        "timeline__button--senior-inactive"
      );
      $(".js-junior").show();
      $(".js-senior").hide();
    } else {
      $(".js-junior").show();
      $(".js-senior").show();
    }
  });
});
